import React from "react";

import { Props } from "./types";

function EyeIcon(props: Props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <g opacity="0.6">
        <g stroke="rgba(0,0,0,0)" strokeWidth="1" opacity="0">
          <rect width="24" height="24" stroke="none" />
          <rect x="0.5" y="0.5" width="23" height="23" fill="none" />
        </g>
        <path
          d="M12,9a3,3,0,1,0,3,3,3,3,0,0,0-3-3m0,8a5,5,0,1,1,5-5,5,5,0,0,1-5,5M12,4.5A11.827,11.827,0,0,0,1,12a11.817,11.817,0,0,0,22,0A11.827,11.827,0,0,0,12,4.5Z"
          transform="translate(0 0.5)"
        />
      </g>
    </svg>
  );
}
export { EyeIcon };
